import { useMemo } from 'react';
import { z } from 'zod';

function applyRules(base, rules = {}) {
  let schema = base;
  if (rules.min != null) schema = schema.min(rules.min, rules.message || `Minimum ${rules.min}`);
  if (rules.max != null) schema = schema.max(rules.max, rules.message || `Maximum ${rules.max}`);
  if (rules.pattern) {
    try {
      const regex = new RegExp(rules.pattern);
      schema = schema.regex(regex, rules.message || 'Invalid format');
    } catch {
      // ignore invalid regex
    }
  }
  return schema;
}

function buildFieldSchema(field) {
  const rules = field.validationRules || {};
  const isRequired = field.isRequired || rules.required;

  let schema;
  switch (field.fieldType) {
    case 'email':
      schema = z.string().email('Invalid email address');
      schema = applyRules(schema, rules);
      break;
    case 'number':
      schema = z.preprocess((v) => (v === '' || v == null ? undefined : Number(v)), z.number());
      break;
    case 'checkbox':
      schema = z.boolean();
      break;
    case 'multiselect':
      schema = z.array(z.string());
      break;
    case 'date':
      schema = z.string();
      break;
    case 'select':
    case 'radio':
    case 'password':
    case 'textarea':
    case 'text':
    default:
      schema = z.string();
      schema = applyRules(schema, rules);
      break;
  }

  if (isRequired) {
    return schema;
  }
  return schema.optional().nullable();
}

export function useDynamicValidation(fields) {
  return useMemo(() => {
    const shape = {};
    (fields || []).forEach((field) => {
      if (!field.fieldKey) return;
      shape[field.fieldKey] = buildFieldSchema(field);
    });
    return z.object(shape);
  }, [fields]);
}


